import { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useFieldArray } from 'react-hook-form';

import useDetailTable from '#/hooks/table/useDetailTable';
import { Button } from '#/modules/commonComponents/button';
import DetailTable from '#/modules/commonComponents/table/DetailTable';
import MtrPickerDialog from '#/modules/imsMgmt/settings/mtr/components/MtrPickerDialog';
import { buildMtrAssemblyColumns } from '#/modules/imsMgmt/settings/mtr/data/mtrAssemblyColumns';

const MtrAssemblyOptionsEditor = ({
  control,
  excludeMtrId = null,
}) => {
  const [pickerOpen, setPickerOpen] = useState(false);
  const [pickerKey, setPickerKey] = useState(0);

  const {
    fields,
    remove,
    replace,
  } = useFieldArray({
    control,
    name: 'assemblyOptions',
  });

  const handleRemove = useCallback((optionMtrId) => {
    const index = fields.findIndex((field) => field.optionMtrId === optionMtrId);
    if (index >= 0) {
      remove(index);
    }
  }, [fields, remove]);

  const columns = useMemo(
    () => buildMtrAssemblyColumns({ onRemove: handleRemove }),
    [handleRemove],
  );

  const tableState = useDetailTable(fields, columns);

  const initialSelectedRows = useMemo(
    () => fields.map((field) => ({
      optionMtrId: field.optionMtrId,
      mtrNo: field.mtrNo ?? '',
      name: field.name ?? '',
      status: field.status ?? '',
    })),
    [fields],
  );

  function handleOpenPicker() {
    setPickerKey((prev) => prev + 1);
    setPickerOpen(true);
  }

  function handlePickerConfirm(selectedRows) {
    replace(selectedRows);
  }

  return (
    <div className="form-section @container/form-section w-full">
      <div className="form-section__header flex flex-wrap items-center justify-between gap-2">
        <h2 className="form-block__title mb-0!">替代子料</h2>
        <Button
          type="button"
          size="sm"
          onClick={handleOpenPicker}
        >
          選擇物料
        </Button>
      </div>

      {fields.length === 0 ? (
        <p className="mt-3 text-sm text-muted-foreground">請選擇至少一筆啟用中的一般物料作為替代子料</p>
      ) : (
        <div className="form-section__body">
          <DetailTable state={tableState} containerClassName="relative min-h-24" />
        </div>
      )}

      <MtrPickerDialog
        key={pickerKey}
        open={pickerOpen}
        onOpenChange={setPickerOpen}
        excludeMtrId={excludeMtrId}
        initialSelectedRows={initialSelectedRows}
        onConfirm={handlePickerConfirm}
      />
    </div>
  );
};

MtrAssemblyOptionsEditor.propTypes = {
  control: PropTypes.object.isRequired,
  excludeMtrId: PropTypes.string,
};

export default MtrAssemblyOptionsEditor;
